import React, {Component, ReactElement, ReactNode} from 'react'

import NatCondominiumRepo from './repository/NatCondominiumRepo'
import {
    AssocOfCondominium,
    ChildUseFunctionInfo,
    CondominiumData,
    NatGetCondominium,
    RidgeInfo,
    UseFunctionInfo,
} from './repository/NatGetCondominium'
import {NatDeleteCondominium} from './repository/NatDeleteCondominium'
import NatCondominiumAuthoritySettingRepo
    from '../condominiumAuthoritySetting/repository/NatCondominiumAuthoritySettingRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import NatUseFunctionMasterRepo from '../useFunctionMaster/repository/NatUseFunctionMasterRepo'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {TableCellProps} from '@mui/material/TableCell';
import {Messages} from '../../../Messages'
import {
    ACCESS_CONTROL_MANAGER,
    ASSOC_ACCOUNTING_DEPT_CD,
    ASSOC_GROUP,
    AVAILABLE_SITE,
    DATE_STRADDLE_RESERVATION_COUNTING_METHOD,
    FACILITY_RESERVATION_CONFIRMED_DATE,
    FACILITY_RESERVATION_DRAWING_END_DATE,
    FACILITY_RESERVATION_DRAWING_START_DATE,
    HAVE_OR_NOT,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    RECEIVING_AGENCY_CD,
    ROLE_FOR_ADMINISTRATOR,
    ROLE_FOR_ADMINISTRATOR_REAL,
    ROLE_FOR_RESIDENT_REAL,
    TARGET_OR_NOT,
    USE_FUNCTION_ID,
    USER_DISPLAY_ITEMS,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {StyledDiv, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {
    AuthorityInfo,
    FunctionDivAuthorityInfo,
    NatGetCondominiumAuthoritySetting,
    RoleAuthorityInfo,
    UseWebsite,
} from '../condominiumAuthoritySetting/repository/NatGetCondominiumAuthoritySetting'
import {
    LightGrayTableHead,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material';
import {
    NatGetUseFunctionMaster,
    UseFunctionMaster,
    UseFunctionMasterInfo,
} from '../useFunctionMaster/repository/NatGetUseFunctionMaster'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {
    NON_EDIT_AUTHORITY_FOR_ADMIN,
    NON_EDIT_AUTHORITY_FOR_RESIDENT,
} from '../condominiumAuthoritySetting/NatAdminCondominiumAuthorityConstant'
import {Sticky, StickyContainer} from 'react-sticky'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    condominiumRepo: NatCondominiumRepo
    condominiumAuthoritySettingRepo: NatCondominiumAuthoritySettingRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    isLoadCompleted: boolean
    adminAuthoritySetting: UseWebsite
    residentAuthoritySetting: UseWebsite
    condominiumInfo: CondominiumData
    useFunctionMaster: UseFunctionMaster[]
    nonEditAuthorityByAdmin: Map<ROLE_FOR_ADMINISTRATOR_REAL, Map<number, number[] | 'all'>>
    nonEditAuthorityByResident: Map<ROLE_FOR_RESIDENT_REAL, Map<number, number[] | 'all'>>
    adminRoleInfos: RoleInfo[]
    residentRoleInfos: RoleInfo[]
}

interface RoleInfo {
    role: ROLE_FOR_ADMINISTRATOR_REAL | ROLE_FOR_RESIDENT_REAL
    group: Nullable<ASSOC_GROUP[]>
}

class NatAdminCondominiumPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            isLoadCompleted: false,
            adminAuthoritySetting: {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            },
            residentAuthoritySetting: {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            },
            condominiumInfo: {
                condominiumCd: '',
                condominiumName: '',
                condominiumGroupName: '',
                condominiumGroupId: 0,
                ridgeInfo: [],
                condominiumFileData: '',
                zipcode: '',
                prefectureCd: '',
                address2: '',
                address3: '',
                businessCenterSupport: '',
                accessControlManagerList: [],
                cardKey: '',
                useFunctionInfo: [],
                assocList: [],
                assocIdUsingAssocFunction: null,
                assocIdUsingApplyFunction: null,
                lotteryReserve: '',
                facilityReserveLotteryStart: '',
                facilityReserveLotteryEnd: '',
                facilityReserveConfirmLimit: '',
                facilityReserveLotteryMonth: 0,
                facilityReserveFasterPeriod: 0,
                dateStraddleReservationCountingMethod: '',
                receivingAgencyCd: '',
                assocAccountingDeptCd: '',
                billingDeadline: '',
                boardUserDisplay: '',
                releaseStartDate: '',
                releaseEndDate: '',
                condominiumContactInfo: [],
                version: 0,
            },
            useFunctionMaster: [],
            nonEditAuthorityByAdmin: NON_EDIT_AUTHORITY_FOR_ADMIN,
            nonEditAuthorityByResident: NON_EDIT_AUTHORITY_FOR_RESIDENT,
            adminRoleInfos: ROLE_FOR_ADMINISTRATOR_REAL.values()
                .filter(role => role !== ROLE_FOR_ADMINISTRATOR_REAL.SYSTEM_ADMIN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_CHAIRMAN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_VICE_CHAIRMAN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.OFFICE_CENTER_OWNERSHIP_TRANSFER)
                .map(role => {
                    if (role.value === ROLE_FOR_ADMINISTRATOR_REAL.ASSOC.value) {
                        return ({role: role, group: ASSOC_GROUP.values()})
                    }
                    return ({role: role, group: null})
                }),
            residentRoleInfos: ROLE_FOR_RESIDENT_REAL.values()
                .filter(role => role !== ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY)
                .map(role => {
                    return ({role: role, group: null})
                }),
        }

        this.handleDeleteCancelClick = this.handleDeleteCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.deleteCondominiumLink = this.deleteCondominiumLink.bind(this)
        this.editCondominium = this.editCondominium.bind(this)
        this.backCondominiumList = this.backCondominiumList.bind(this)
        this.editCondominiumAuthority = this.editCondominiumAuthority.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // 利用機能マスタ一覧取得
            const useFunctionMasterResponse: Nullable<NatGetUseFunctionMaster> = await this.props.asyncCallFunction(
                this.props.useFunctionMasterRepo.getUseFunctionMaster.bind(this.props.useFunctionMasterRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (useFunctionMasterResponse && useFunctionMasterResponse.details) {
                this.setState({
                    useFunctionMaster: useFunctionMasterResponse.details,
                })
            }

            // 物件取得
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(this.props.condominiumRepo, this.props.condominiumCd),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {

                this.setState({
                    condominiumInfo: condominiumResponse.details,
                })
            }

            // 物件権限設定一覧取得
            const retCondominiumAuthoritySetting: Nullable<NatGetCondominiumAuthoritySetting> =
                await this.props.asyncCallFunction(
                    this.props.condominiumAuthoritySettingRepo.getCondominiumAuthoritySetting.bind(
                        this.props.condominiumAuthoritySettingRepo, this.props.condominiumCd),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            let adminAuthoritySetting: UseWebsite = {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            }
            let residentAuthoritySetting: UseWebsite = {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            }

            const sortOrderForAdministrator: string[] = ROLE_FOR_ADMINISTRATOR.values()
                .flatMap(role => {
                    if (role.value === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                        return [...ASSOC_GROUP.values().map(assocRole => assocRole.value)]
                    }
                    return role.value
                })

            if (retCondominiumAuthoritySetting && retCondominiumAuthoritySetting.details) {
                retCondominiumAuthoritySetting.details.websiteFunctionDivAutorityInfo
                    .forEach((websiteFunctionDivAutority) => {
                        // 管理者権限、居住者権限とで分ける
                        if (websiteFunctionDivAutority.useWebsite === AVAILABLE_SITE.ADMIN.value) {
                            // システム運用スタッフと事務センター（重調担当）は、除外する
                            adminAuthoritySetting = {
                                useWebsite: websiteFunctionDivAutority.useWebsite,
                                functionDivAuthorityInfo: this.exclusionTargetRoll(
                                    websiteFunctionDivAutority,
                                    [
                                        ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN,
                                        ROLE_FOR_ADMINISTRATOR.OFFICE_CENTER_OWNERSHIP_TRANSFER,
                                    ],
                                ),
                            }
                            adminAuthoritySetting.functionDivAuthorityInfo
                                .forEach(functionDivAuthorityInfo => functionDivAuthorityInfo.authorityInfo
                                    .forEach(authorityInfo => authorityInfo.roleAuthorityInfo
                                        .sort((e1, e2) => sortOrderForAdministrator.indexOf(e1.roleId)
                                            - sortOrderForAdministrator.indexOf(e2.roleId))))
                        } else {
                            // 入居前は、除外する
                            residentAuthoritySetting = {
                                useWebsite: websiteFunctionDivAutority.useWebsite,
                                functionDivAuthorityInfo: this.exclusionTargetRoll(
                                    websiteFunctionDivAutority,
                                    [ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY],
                                ),
                            }
                        }
                    })
            }

            this.setState({
                adminAuthoritySetting: adminAuthoritySetting,
                residentAuthoritySetting: residentAuthoritySetting,
            })

            this.showInitialMessage()

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    exclusionTargetRoll(
        websiteFunctionDivAuthority: UseWebsite,
        exclusionRoles: (ROLE_FOR_ADMINISTRATOR | ROLE_FOR_RESIDENT_REAL)[],
    ): FunctionDivAuthorityInfo[] {
        const functionDivAuthorityInfo: FunctionDivAuthorityInfo[] = []
        const exclusionRoleValues = exclusionRoles.map((role) => role.value)
        websiteFunctionDivAuthority.functionDivAuthorityInfo.map((functionDivAuthority) => {
            const authorityInfo: AuthorityInfo[] = []
            functionDivAuthority.authorityInfo.map((authority) => {
                const roleAuthorityInfo: RoleAuthorityInfo[] = []
                authority.roleAuthorityInfo.map((role) => {
                    if (!exclusionRoleValues.includes(role.roleId)) {
                        roleAuthorityInfo.push(role)
                    }
                })
                authorityInfo.push({
                    authority: authority.authority,
                    authorityName: authority.authorityName,
                    roleAuthorityInfo,
                })
            })
            functionDivAuthorityInfo.push({
                functionDivId: functionDivAuthority.functionDivId,
                functionDivName: functionDivAuthority.functionDivName,
                authorityInfo: authorityInfo,
            })
        })
        return functionDivAuthorityInfo
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }


    editCondominium(): void {
        this.props.navigate(
            `/admin/condominiumEdit/${this.props.condominiumCd}`,
        )
    }

    editCondominiumAuthority(): void {
        this.props.navigate(
            `/admin/condominiumAuthoritySetting/${this.props.condominiumCd}`,
        )
    }

    backCondominiumList(): void {
        this.props.navigate(
            `/admin/condominiumList`,
        )
    }


    // 物件削除リンク押下
    async deleteCondominiumLink(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WCONA0001.errorLevel,
                message: Messages.WCONA0001.toString(this.state.condominiumInfo.condominiumName),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleDeleteCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkClick,
                    },
                ],
            },
        )
    }

    handleDeleteCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkClick(): Promise<void> {

        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            const deleteCondominiumResponse: Nullable<NatDeleteCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.deleteCondominium.bind(this.props.condominiumRepo, this.props.condominiumCd),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (deleteCondominiumResponse && deleteCondominiumResponse.requestError === null) {
                this.props.navigate(
                    `/admin/condominiumList`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0006.toString('物件', this.state.condominiumInfo.condominiumName),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }


    condominiumListLinkClick(): void {
        this.props.navigate(
            '/admin/condominiumList/',
        )
    }


    renderPageHeaderArea(): ReactElement {
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CONDOMINIUM}>
                    <PageFotterAreaRight>
                        <DeleteLink
                            onClick={this.deleteCondominiumLink}>
                            物件を削除する
                        </DeleteLink>
                    </PageFotterAreaRight>
                    <PageFotterAreaLeft>
                        <AdminDefaultMediumButton
                            onClick={this.editCondominium}>
                            物件編集
                        </AdminDefaultMediumButton>
                    </PageFotterAreaLeft>
                </AuthorityChecker>
            </>
        )
    }

    getPrefectureName(prefectureCd: string): string {
        const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
        if (prefecturesMaster) {
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    getTargetOrNotLabel(value: string): string {
        const targetOrNotMaster = TARGET_OR_NOT.codeToEnumConstants(value)
        if (targetOrNotMaster) {
            return targetOrNotMaster.label
        } else {
            return ''
        }
    }

    getHaveOrNotLabel(value: string): string {
        const haveOrNotMaster = HAVE_OR_NOT.codeToEnumConstants(value)
        if (haveOrNotMaster) {
            return haveOrNotMaster.label
        } else {
            return ''
        }
    }

    getUserDisplayItemsLabel(value: string): string {
        const userDisplayItemsMaster = USER_DISPLAY_ITEMS.codeToEnumConstants(value)
        if (userDisplayItemsMaster) {
            return userDisplayItemsMaster.label
        } else {
            return ''
        }
    }

    getFacilityReservationDrawingStartDateLabel(value: string): string {
        const facilityReservationDrawingStartDateMaster =
            FACILITY_RESERVATION_DRAWING_START_DATE.codeToEnumConstants(value)
        if (facilityReservationDrawingStartDateMaster) {
            return facilityReservationDrawingStartDateMaster.label
        } else {
            return ''
        }
    }

    getFacilityReservationDrawingEndDateLabel(value: string): string {
        const facilityReservationDrawingEndtDateMaster =
            FACILITY_RESERVATION_DRAWING_END_DATE.codeToEnumConstants(value)
        if (facilityReservationDrawingEndtDateMaster) {
            return facilityReservationDrawingEndtDateMaster.label
        } else {
            return ''
        }
    }

    getFacilityReservationConfirmedDateLabel(value: string): string {
        if (!value) {
            return ''
        }
        const facilityReservationConfirmedDateMaster = FACILITY_RESERVATION_CONFIRMED_DATE.codeToEnumConstants(value)
        if (facilityReservationConfirmedDateMaster) {
            return (facilityReservationConfirmedDateMaster.label + '日')
        } else {
            return ''
        }
    }

    getUseFunctionValidLabel(useFunctionMaster: UseFunctionMaster): string {
        const condominiumUseFunctionInfo = this.state.condominiumInfo.useFunctionInfo
            .find(condominiumUseFunction =>
                condominiumUseFunction.functionId === useFunctionMaster.useFunctionInfo.functionId)

        if (condominiumUseFunctionInfo &&
            condominiumUseFunctionInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value) {
            return VALID_OR_NOT_CHECK.VALID.label + useFunctionMaster.useFunctionInfo.useFunctionName
        } else {
            return '　' + useFunctionMaster.useFunctionInfo.useFunctionName
        }
    }

    getChildUseFunctionValidLabel(
        useFunctionMaster: UseFunctionMaster,
        childUseFunctionMaster: UseFunctionMasterInfo,
    ): string {
        const condominiumUseFunctionInfo = this.state.condominiumInfo.useFunctionInfo
            .find(condominiumUseFunction =>
                condominiumUseFunction.functionId === useFunctionMaster.useFunctionInfo.functionId)

        if (!condominiumUseFunctionInfo) {
            return '　' + childUseFunctionMaster.useFunctionName
        }

        const condominiumChildUseFunctionInfo = condominiumUseFunctionInfo.childUseFunctionInfo
            .find(condominiumChildUseFunction =>
                condominiumChildUseFunction.functionId === childUseFunctionMaster.functionId)

        if (condominiumChildUseFunctionInfo &&
            condominiumChildUseFunctionInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value) {
            return VALID_OR_NOT_CHECK.VALID.label + childUseFunctionMaster.useFunctionName
        } else {
            return '　' + childUseFunctionMaster.useFunctionName
        }
    }

    renderUseFunctionRow(useFunctionInfo: UseFunctionMaster, index: number): ReactElement {
        if (!useFunctionInfo) {
            return (<></>)
        }

        let rowSpan: number = 0
        if (index === 0) {
            rowSpan = this.state.useFunctionMaster.length
            this.state.useFunctionMaster.forEach(master => {
                if (master.childUseFunctionInfo.length > 0) {
                    rowSpan = rowSpan + 1
                }
            })
        }

        return (
            <React.Fragment key={index}>
                <TableRow>
                    {index === 0 && <TableRowName rowSpan={rowSpan}>機能一覧</TableRowName>}
                    <TableCell colSpan={3}>
                        {this.getUseFunctionValidLabel(useFunctionInfo)}
                    </TableCell>
                </TableRow>
                {useFunctionInfo.childUseFunctionInfo.length > 0 &&
                    <TableRow>
                        <ChildUseFunctionTableCell colSpan={3}>
                            <Table>
                                <TableBody>
                                    {useFunctionInfo.childUseFunctionInfo.map((childUseFunction, childIndex) =>
                                        <TableRow key={childUseFunction.functionId}>
                                            {childIndex === 0
                                                && <NoBorderTableCell
                                                    rowSpan={useFunctionInfo.childUseFunctionInfo.length}
                                                    bottomNone/>
                                            }
                                            <NoBorderTableCell
                                                bottomNone={childIndex ===
                                                    useFunctionInfo.childUseFunctionInfo.length - 1}>
                                                {this.getChildUseFunctionValidLabel(useFunctionInfo, childUseFunction)}
                                            </NoBorderTableCell>
                                        </TableRow>,
                                    )}
                                </TableBody>
                            </Table>
                        </ChildUseFunctionTableCell>
                    </TableRow>
                }
            </React.Fragment>
        )
    }

    renderAssocList(): ReactNode {
        return (<>
            <AssocListTable>
                <LightGrayTableHead>
                    <TableRow>
                        <AssocCdTableCell>組合コード</AssocCdTableCell>
                        <AssocNameTableCell>組合名</AssocNameTableCell>
                        <AssocNameTableCell>上の管理組合</AssocNameTableCell>
                        {
                            this.state.condominiumInfo.assocIdUsingAssocFunction &&
                            <AssocFunctionTableCell>理事会</AssocFunctionTableCell>
                        }
                        {
                            this.state.condominiumInfo.assocIdUsingApplyFunction &&
                            <ApplyFunctionTableCell>申請</ApplyFunctionTableCell>
                        }
                    </TableRow>
                </LightGrayTableHead>
                <TableBody>
                    {this.state.condominiumInfo.assocList.map((assocList, index) => (
                        <TableRow key={`${assocList.assocId}-${index}`}>
                            <AssocCdTableCell>
                                {assocList.assocCd}
                            </AssocCdTableCell>
                            <AssocNameTableCell>
                                {assocList.assocName}
                            </AssocNameTableCell>
                            <AssocNameTableCell>
                                {renderParentAssocInfo(
                                    this.state.condominiumInfo.assocList,
                                    assocList.parentAssocId,
                                )}
                            </AssocNameTableCell>
                            {
                                this.state.condominiumInfo.assocIdUsingAssocFunction &&
                                <AssocFunctionTableCell>
                                    {
                                        Number(assocList.assocId) ===
                                        this.state.condominiumInfo.assocIdUsingAssocFunction &&
                                        VALID_OR_NOT_CHECK.VALID.label
                                    }
                                </AssocFunctionTableCell>
                            }
                            {
                                this.state.condominiumInfo.assocIdUsingApplyFunction &&
                                <ApplyFunctionTableCell>
                                    {
                                        Number(assocList.assocId) ===
                                        this.state.condominiumInfo.assocIdUsingApplyFunction &&
                                        VALID_OR_NOT_CHECK.VALID.label
                                    }
                                </ApplyFunctionTableCell>
                            }
                        </TableRow>
                    ))}
                </TableBody>
            </AssocListTable>
        </>)
    }

    renderLotteryReserveRelatedItem(): ReactElement {
        if (this.state.condominiumInfo.lotteryReserve !== HAVE_OR_NOT.HAVE.value) {
            return (<></>)
        } else {
            return (
                <>
                    <TableRow>
                        <TableRowName>施設予約抽選期間</TableRowName>
                        <TableCell colSpan={3}>
                            {this.getFacilityReservationDrawingStartDateLabel
                            (this.state.condominiumInfo.facilityReserveLotteryStart)}
                            日から
                            {this.getFacilityReservationDrawingEndDateLabel
                            (this.state.condominiumInfo.facilityReserveLotteryEnd)}
                            日
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>施設予約確定日</TableRowName>
                        <TableCell colSpan={3}>
                            {this.getFacilityReservationConfirmedDateLabel
                            (this.state.condominiumInfo.facilityReserveConfirmLimit)}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>施設予約抽選対象月</TableRowName>
                        <TableCell colSpan={3}>
                            {this.state.condominiumInfo.facilityReserveLotteryMonth}ヶ月後
                            （施設予約先着対象期間 {this.state.condominiumInfo.facilityReserveFasterPeriod}ヶ月）
                        </TableCell>
                    </TableRow>
                </>
            )
        }
    }

    renderDateStraddleReservationCountingMethodItem(): ReactElement {
        const {useFunctionInfo} = this.state.condominiumInfo
        return isReserveFacilityAvailable(useFunctionInfo) ?
            <>
                <TableRow>
                    <TableRowName>日またぎの予約回数の数え方</TableRowName>
                    <TableCell colSpan={3}>
                        {DATE_STRADDLE_RESERVATION_COUNTING_METHOD.codeToEnumConstants(
                            this.state.condominiumInfo.dateStraddleReservationCountingMethod,
                        ).label}
                    </TableCell>
                </TableRow>
            </> : <></>
    }

    renderAccountTransferItem(): ReactElement {
        const {useFunctionInfo, assocAccountingDeptCd, receivingAgencyCd} = this.state.condominiumInfo
        return isAccountTransferAvailable(useFunctionInfo) ?
            <>
                <TableRow>
                    <TableRowName>担当組合会計部</TableRowName>
                    <TableCell>
                        {ASSOC_ACCOUNTING_DEPT_CD.codeToEnumConstants(assocAccountingDeptCd).label}
                    </TableCell>
                    <TableRowName>収納代行会社</TableRowName>
                    <TableCell>
                        {RECEIVING_AGENCY_CD.codeToEnumConstants(receivingAgencyCd).label}
                    </TableCell>
                </TableRow>
            </> : <></>
    }

    renderPageBodyCondominiumInfoArea(): ReactElement {
        let accessControlManagerListString = 'なし'
        const {accessControlManagerList} = this.state.condominiumInfo
        if (accessControlManagerList.length !== 0) {
            accessControlManagerListString = accessControlManagerList
                .map(accessControlManager =>
                    ACCESS_CONTROL_MANAGER.codeToEnumConstants(accessControlManager).label)
                .join('，')
        }

        return (
            <>
                <Box marginTop={'10px'}>
                    <Table>
                        <StyledTableCaption>物件情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName>物件グループ</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumInfo.condominiumGroupName}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>物件コード</TableRowName>
                                <TableCell colSpan={2}>
                                    {this.state.condominiumInfo.condominiumCd}
                                </TableCell>
                                <TableCell rowSpan={2 + this.state.condominiumInfo.ridgeInfo.length}>
                                    <TableCellImg>
                                        <CondominiumImg
                                            src={
                                                this.state.condominiumInfo.condominiumFileData ?
                                                    this.state.condominiumInfo.condominiumFileData + '?' +
                                                    String(this.state.condominiumInfo.version)
                                                    : `/resources/images/upload/img_noupload.png`
                                            }
                                            alt=""
                                        />
                                    </TableCellImg>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>物件名</TableRowName>
                                <TableCellWordBreakAll colSpan={2}>
                                    {this.state.condominiumInfo.condominiumName}
                                </TableCellWordBreakAll>
                            </TableRow>
                            {this.state.condominiumInfo.ridgeInfo.map((ridgeInfo, index) => (
                                this.renderRidgeRow(ridgeInfo, index)
                            ))
                            }
                            <TableRow>
                                <TableRowName>郵便番号</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumInfo.zipcode}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>都道府県</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.getPrefectureName(this.state.condominiumInfo.prefectureCd)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>市区町村</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumInfo.address2}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>番地</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumInfo.address3}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>連絡先メールアドレス1</TableRowName>
                                <TableCell colSpan={3}>
                                    {(this.state.condominiumInfo.condominiumContactInfo[0]) ?
                                        this.state.condominiumInfo.condominiumContactInfo[0].mailAddress : ''}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>連絡先メールアドレス2</TableRowName>
                                <TableCell colSpan={3}>
                                    {(this.state.condominiumInfo.condominiumContactInfo[1]) ?
                                        this.state.condominiumInfo.condominiumContactInfo[1].mailAddress : ''}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>事務センター対応</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.getTargetOrNotLabel(this.state.condominiumInfo.businessCenterSupport)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>入退室管理</TableRowName>
                                <TableCell colSpan={3}>
                                    {accessControlManagerListString}
                                </TableCell>
                            </TableRow>
                            {this.state.useFunctionMaster.map((useFunctionMasterInfo, index) => (
                                this.renderUseFunctionRow(useFunctionMasterInfo, index)
                            ))
                            }
                            <TableRow>
                                <TableRowName>管理組合</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.renderAssocList()}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>抽選予約</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.getHaveOrNotLabel(this.state.condominiumInfo.lotteryReserve)}
                                </TableCell>
                            </TableRow>
                            {this.renderLotteryReserveRelatedItem()}
                            {this.renderDateStraddleReservationCountingMethodItem()}
                            {this.renderAccountTransferItem()}
                            <TableRow>
                                <TableRowName>請求締め日</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.condominiumInfo.billingDeadline}日
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>掲示板ユーザ表示</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.getUserDisplayItemsLabel(this.state.condominiumInfo.boardUserDisplay)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>公開開始日</TableRowName>
                                <TableCell>
                                    {this.state.condominiumInfo.releaseStartDate !== null &&
                                        formatDateZeroPadding(this.state.condominiumInfo.releaseStartDate)
                                    }
                                    {this.state.condominiumInfo.releaseStartDate === null &&
                                        '未設定'
                                    }
                                </TableCell>
                                <TableRowName>公開終了日</TableRowName>
                                <TableCell>
                                    {this.state.condominiumInfo.releaseEndDate !== null &&
                                        formatDateZeroPadding(this.state.condominiumInfo.releaseEndDate)
                                    }
                                    {this.state.condominiumInfo.releaseEndDate === null &&
                                        '未設定'
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </>
        )
    }


    renderAuthoritySettingTable(adminAuthoritySetting: UseWebsite): Nullable<ReactElement> {
        if (adminAuthoritySetting.functionDivAuthorityInfo.length === 0 ||
            adminAuthoritySetting.functionDivAuthorityInfo[0].authorityInfo.length === 0 ||
            adminAuthoritySetting.functionDivAuthorityInfo[0].authorityInfo[0].roleAuthorityInfo.length === 0
        ) {
            return null
        }

        const {adminRoleInfos, residentRoleInfos} = this.state

        const useWebsite = adminAuthoritySetting.useWebsite
        const roleInfos = useWebsite === AVAILABLE_SITE.ADMIN.value ?
            adminRoleInfos : residentRoleInfos

        let roleLength: number = 0
        roleInfos.forEach((roleInfo) => {
            roleInfo.group ?
                roleLength = roleLength + roleInfo.group.length :
                roleLength = roleLength + 1
        })

        const header =
            <>
                <FlexTableHeaderNotGrowItem style={{width: '30%'}}>
                    {(useWebsite === AVAILABLE_SITE.ADMIN.value) ?
                        '管理者権限' : '居住者権限'}
                </FlexTableHeaderNotGrowItem>
                {roleInfos.map((roleInfo, index) =>
                    !roleInfo.group ?
                        <FlexTableHeaderItem
                            key={index}
                            style={{width: `calc((100% - 30%)/${roleLength})`}}>
                            {roleInfo.role.label}
                        </FlexTableHeaderItem> :
                        <FlexTableHeaderNotGrowItem
                            key={index}
                            style={{width: `calc((100% - 30%)/${roleLength} * ${roleInfo.group.length} * 0.725)`}}>
                            <Box style={{textAlign: `left`}} pl={'20px'} pb={'20px'}>
                                {roleInfo.role.label}
                            </Box>
                            <Box display={'flex'}>
                                {roleInfo.group.map((group, groupIndex) => {
                                    const groupLength = roleInfo.group?.length ?? 0
                                    return (
                                        <Box key={groupIndex} style={{flexBasis: `calc(100%/${groupLength})`}}>
                                            {group.label}
                                        </Box>
                                    )
                                })}
                            </Box>
                        </FlexTableHeaderNotGrowItem>,
                )}
            </>

        return (
            <>
                <StickyContainer>
                    <Sticky>
                        {({style}) =>
                            <FlexTableHeaderContainer style={style}>
                                {header}
                            </FlexTableHeaderContainer>
                        }
                    </Sticky>
                    <ConditionTableFixed>
                        <colgroup>
                            <col width={'18%'}/>
                            <col width={'12%'}/>
                            {roleInfos.map((roleInfo, roleInfoIndex) =>
                                !roleInfo.group ?
                                    <col key={roleInfoIndex} width={`auto`}/> :
                                    roleInfo.group.map((group, groupIndex) =>
                                        <col key={groupIndex}
                                             style={{width: `calc((100% - 30%)/${roleLength} * 0.725)`}}/>,
                                    ),
                            )}
                        </colgroup>
                        <TableBody>
                            {
                                adminAuthoritySetting.functionDivAuthorityInfo.map(
                                    (functionDivAuthority, functionDivAuthorityIndex) => (
                                        <React.Fragment key={`functionDivAuthority_ ${functionDivAuthorityIndex}`}>
                                            {
                                                functionDivAuthority.authorityInfo.map((authority, index) => (
                                                    <React.Fragment key={`authority_${index}`}>
                                                        {this.renderCell(
                                                            useWebsite,
                                                            functionDivAuthority,
                                                            authority,
                                                            index)}
                                                    </React.Fragment>
                                                ))
                                            }
                                        </React.Fragment>
                                    ))
                            }
                        </TableBody>
                    </ConditionTableFixed>
                </StickyContainer>
            </>
        )
    }

    renderCell(
        useWebsite: string,
        functionDivAuthority: FunctionDivAuthorityInfo,
        authorityInfo: AuthorityInfo,
        index: number,
    ): Nullable<ReactElement> {
        const {nonEditAuthorityByAdmin, nonEditAuthorityByResident} = this.state

        const functionDivId = Number(functionDivAuthority.functionDivId)
        const authorityId = Number(authorityInfo.authority)

        return (
            <TableRow>
                {index === 0 &&
                    <TableCell align={'left'}
                               rowSpan={functionDivAuthority.authorityInfo.length}>
                        {functionDivAuthority.functionDivName}
                    </TableCell>
                }
                <TableCell align={'left'} key={index}>{authorityInfo.authorityName}</TableCell>
                {
                    authorityInfo.roleAuthorityInfo.map((authority, roleAuthorityIndex) => {
                        const roleIdMaster = useWebsite === AVAILABLE_SITE.ADMIN.value ?
                            ROLE_FOR_ADMINISTRATOR_REAL.codeToEnumConstants(authority.roleId) :
                            ROLE_FOR_RESIDENT_REAL.codeToEnumConstants(authority.roleId)
                        const nonEditAuthorityInfo = useWebsite === AVAILABLE_SITE.ADMIN.value ?
                            nonEditAuthorityByAdmin : nonEditAuthorityByResident

                        const nonEditAuthority = nonEditAuthorityInfo.get(roleIdMaster)?.get(functionDivId)
                        const isEditable = !(nonEditAuthority !== undefined &&
                            (nonEditAuthority === 'all' ||
                                nonEditAuthority.includes(authorityId)))

                        if (isEditable) {
                            return (
                                <TableCell align={'center'} key={`roleAuthorityInfo_${roleAuthorityIndex}`}>
                                    {(authority.validFlag === VALID_OR_NOT_CHECK.NOT.value) ?
                                        VALID_OR_NOT_CHECK.NOT.label :
                                        VALID_OR_NOT_CHECK.VALID.label}
                                </TableCell>
                            )
                        } else {
                            return <NonEditTableCell key={`roleAuthorityInfo_${roleAuthorityIndex}`}/>
                        }
                    })
                }
            </TableRow>
        )
    }


    renderPageBodyCondominiumAuthorityInfoArea(): ReactNode {
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CONDOMINIUM}>
                    <Box marginTop={'10px'}>
                        <PageFotterAreaLeft>
                            <AdminDefaultMediumButton
                                onClick={this.editCondominiumAuthority}>
                                権限編集
                            </AdminDefaultMediumButton>
                        </PageFotterAreaLeft>
                    </Box>
                </AuthorityChecker>
                <Box marginTop={'10px'}>
                    <Table>
                        <StyledTableCaption>権限情報</StyledTableCaption>
                    </Table>
                </Box>
                {this.renderAuthoritySettingTable(this.state.adminAuthoritySetting)}
                <Box marginTop={'30px'}>
                    {this.renderAuthoritySettingTable(this.state.residentAuthoritySetting)}
                </Box>
            </>
        )
    }

    renderRidgeRow(ridgeInfo: RidgeInfo, index: number): ReactNode {
        if (!ridgeInfo) {
            return (<></>)
        }
        if (index === 0) {
            return (
                <TableRow key={index}>
                    <TableRowName rowSpan={this.state.condominiumInfo.ridgeInfo.length}>棟</TableRowName>
                    <TableCell colSpan={2}>
                        {ridgeInfo.ridgeCd}：{ridgeInfo.ridgeName}
                    </TableCell>
                </TableRow>
            )
        } else {
            return (
                <TableRow key={index}>
                    <TableCell colSpan={2}>
                        {ridgeInfo.ridgeCd}：{ridgeInfo.ridgeName}
                    </TableCell>
                </TableRow>
            )
        }
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backCondominiumList}
                    >
                        物件一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageFooterArea>
                    {this.renderPageHeaderArea()}
                </PageFooterArea>
                <PageMainArea>
                    {this.renderPageBodyCondominiumInfoArea()}
                    {this.renderPageBodyCondominiumAuthorityInfoArea()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

function isFunctionAvailable(
    useFunctions: UseFunctionInfo[] | ChildUseFunctionInfo[],
    useFunctionId: USE_FUNCTION_ID,
): boolean {
    return useFunctions.some(functionInfo => {
        return functionInfo.functionId === Number(useFunctionId.value)
            && functionInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value
    })
}

function isReserveFacilityAvailable(useFunctions: UseFunctionInfo[]): boolean {
    return isFunctionAvailable(useFunctions, USE_FUNCTION_ID.FACILITY)
}

function isAccountTransferAvailable(useFunctions: UseFunctionInfo[]): boolean {
    const childUseFunctions = useFunctions.find(info =>
        info.functionId === Number(USE_FUNCTION_ID.ACCOUNT_TRANSFER.value))?.childUseFunctionInfo
    if (!childUseFunctions) {
        return false
    }
    return isFunctionAvailable(childUseFunctions, USE_FUNCTION_ID.WEB_ACCOUNT_TRANSFER)
}

function renderParentAssocInfo(
    assocList: AssocOfCondominium[],
    parentAssocId: Nullable<number>,
): string {
    const parentAssocInfo = assocList.find(assoc => assoc.assocId === parentAssocId)
    return parentAssocInfo ? `${parentAssocInfo.assocCd}：${parentAssocInfo.assocName}` : 'ー'
}

const TableCellImg: StyledDiv = styled.div`
  width: 400px;
  margin-left: auto;
  margin-right: auto;
`

const CondominiumImg: StyledImg = styled.img`
  width: 100%;
  height: auto;
`

export default createAdminPage(NatAdminCondominiumPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const NonEditTableCell = styled(TableCell)`
  background-color: rgba(0, 0, 0, 0.12);
`

const ChildUseFunctionTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding: 0;
  }
`

const NoBorderTableCell =
    styled(({bottomNone, ...props}) => (<TableCell {...props} />))<TableCellProps & { bottomNone?: boolean }>`
      &.MuiTableCell-root {
        ${props => (props.bottomNone) ? `border-bottom: 0 solid` : ''};
      }
    `

const FlexTableHeaderContainer = styled.div`
  display: flex;
  color: inherit;
  outline: 0;
  vertical-align: middle;
  width: 100%;
`

const FlexTableHeaderItem = styled.div`
  flex: 1 0 auto;
  background-color: #fafafa;
  text-align: center;
  padding: 14px 12px 14px 12px;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
`

const FlexTableHeaderNotGrowItem = styled(FlexTableHeaderItem)`
  flex: 0 0 auto;
`

const AssocListTable = styled(Table)`
  .MuiTableHead-root .MuiTableCell-root {
    padding: 8px 16px;
  }

  .MuiTableCell-root {
    padding: 16px;
  }
`

const AssocCdTableCell = styled(TableCell)`
  width: 102px;
  min-width: 102px;
`

const AssocNameTableCell = styled(TableCell)`
  width: 412px;
  overflow-wrap: anywhere;
`

const AssocFunctionTableCell = styled(TableCell)`
  width: 74px;
  min-width: 74px;
  vertical-align: middle;
  text-align: center;
`

const ApplyFunctionTableCell = styled(TableCell)`
  width: 60px;
  min-width: 60px;
  vertical-align: middle;
  text-align: center;
`
